(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:ShowDistWarningCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('ShowDistWarningCtrl', ShowDistWarningCtrl);

    function ShowDistWarningCtrl($uibModalInstance, modalParams, MessageService, CrewingHelper, $timeout) {
        var vm = this;

        vm.model = {
            title:'Violation Reasons',
            message:[],
            params:{},
            violations:[]
        };

        (function Init(){
            vm.model.params.crewProfileId = modalParams.crewProfileID;
            vm.model.params.pairingId = modalParams.pairingID;
            loadViolations();
        }());

        function loadViolations(){
            CrewingHelper.checkDistributionWarning(
                vm.model.params.pairingId,
                vm.model.params.crewProfileId, 
                callBackForViolations,
                errorFn
            );
        }

        function callBackForViolations(response) {
            $timeout(function(){
                vm.model.violations = [response];
            },0)
        }
        
        function errorFn(msg) {
            MessageService.error(msg);
        }

        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };

    }
}());